<template>
  <div>
    <ul class="select-bank">
      <li>
        <div class="li-l">
          {{ $t("wallet.openingBank") }}
        </div>
        <div class="li-r">
          <Select
            v-model="bankId"
            :placeholder="$t('wallet.selectOpeningBank')"
            @on-change="changeSelect"
          >
            <Option
              v-for="(item, index) in list"
              :value="item.bank_id"
              :key="index"
            >
              {{ item.bank_name }}
            </Option>
          </Select>
        </div>
      </li>
      <li>
        <div class="li-l">{{ $t("wallet.accountNumber") }}</div>
        <div class="li-r">
          {{ bank.bank_username ? bank.bank_username : "--" }}
        </div>
      </li>
      <li>
        <div class="li-l">{{ $t("wallet.bankCardNumber") }}</div>
        <div class="li-r">
          {{ bank.card_number ? bank.card_number : "--" }}
        </div>
      </li>
      <li v-if="bank.country == 1 || bank.country == 3">
        <div class="li-l">{{ $t("common.rate") }}</div>
        <div class="li-r">
          {{ bank.exchange_rate_show }}
        </div>
      </li>
    </ul>
    <div class="button-wrap">
      <Button type="primary" long @click="confirmFun">
        {{ $t("common.cashinNow") }}
      </Button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["selectBankFlag", "list", "bank", "params"],
  name: "",
  components: {},
  data() {
    return {
      bankId: ""
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    changeSelect(value) {
      console.log("changeSelect", value);
      for (let key of this.list) {
        if (key.bank_id == value) {
          this.$emit("update:bank", key);
        }
      }
    },
    confirmFun() {
      // 确认
      let vm = this;
      if (vm.bank.bank_id == "") {
        vm.$Message.warning(vm.$t("wallet.selectBankCard"));
        return false;
      }
      let params = vm.params;
      params.bank_id = vm.bank.bank_id;
      params.exchange_rate = vm.bank.exchange_rate;
      vm.$post("/app/pay/bankCard_pay", params, { loading: true }).then(res => {
        console.log("bankCard_pay", res);
        vm.$emit("getBankInfo", res);
        vm.$emit("update:selectBankFlag", false);
      });
    }
  },
  watch: {}
};
</script>

<style scoped lang="less">
.select-bank {
  width: 400px;
  margin: 0 auto 50px;
  > li {
    margin: 8px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    height: 32px;
    .li-l {
      width: 120px;
    }
    .li-r {
      flex: 1;
    }
  }
}
</style>
